// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"66":"f9e94ee7","143":"f525a4b0","148":"8f3c25fc","211":"33b1dc85","323":"3af31c9e","543":"69ab77e0","638":"93916216","824":"b95039cd","896":"cf045e78"}[chunkId] + ".chunk.css";
};